<template>
  <div class="label" @click.stop v-if="label">
    <em v-if="required" class="required">*</em>
    {{ label }}
    <template v-if="tip && tipImg.length === 0">
      <van-icon name="question-o" class="ico" @click="showToast(tip)" />
    </template>
    <template v-if="tipImg.length > 0">
      <van-icon name="question-o" class="ico" @click="showTipImgPopup = true" />
      <TipImgPopup
        v-bind:visible.sync="showTipImgPopup"
        :tipImg="tipImg"
        :tip="tip"
        @closePopup="showTipImgPopup = false"
      ></TipImgPopup
    ></template>
  </div>
</template>

<script>
import TipImgPopup from './TipImgPopup.vue';
export default {
  name: 'HelpTip',
  props: {
    tip: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    },
    tipImg: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      showPopover: false,
      showTipImgPopup: false
    };
  },
  methods: {
    showToast(tip) {
      this.$toast(tip);
    }
  },
  components: {
    TipImgPopup
  }
};
</script>

<style lang="scss" scoped>
.label {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
  font-size: 16px;
  word-break: break-word;
  line-height: 20px;
}
.text {
  padding: 10px;
  line-height: 20px;
  font-size: 16px;
}
.required {
  color: red;
  margin-right: 2px;
}
.ico {
  margin-left: 8px !important;
  font-size: 17px;
}
</style>
